//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Registers new user in the system.
 * @param dto Data for the user creation.
 */
export function registerNewUser(dto: Types.RegisterNewUserDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/user";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeRegisterNewUserDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRegisterNewUser,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigRegisterNewUser?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRegisterNewUser(_response);
    });
}

function processRegisterNewUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Confirms user's email and activates account
 * @param dto Data for email confirmation.
 */
export function confirmUserMail(dto: Types.ConfirmUserMailDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/user/confirm";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeConfirmUserMailDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigConfirmUserMail,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigConfirmUserMail?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processConfirmUserMail(_response);
    });
}

function processConfirmUserMail(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Resets user's password and sends an e-mail with token to setup new one.
 * @param userEmail (optional) User e-mail for whom password should be reset.
 */
export function sendPasswordForgotten(userEmail?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/user/password-forgotten?";
    if (userEmail === null)
        throw new Error("The parameter 'userEmail' cannot be null.");
    else if (userEmail !== undefined)
        url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendPasswordForgotten,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendPasswordForgotten?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendPasswordForgotten(_response);
    });
}

function processSendPasswordForgotten(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Resets user's password with the given token.
 * @param dto Data for password changing.
 */
export function resetPassword(dto: Types.ResetPasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/user/reset-password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeResetPasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetPassword,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResetPassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetPassword(_response);
    });
}

function processResetPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Returns user's info.
 */
export function getMyInfo(config?: AxiosRequestConfig | undefined): Promise<Types.UserInfoDto> {
    let url_ = getBaseUrl() + "/api/user/my-info";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMyInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetMyInfo?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMyInfo(_response);
    });
}

function processGetMyInfo(response: AxiosResponse): Promise<Types.UserInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUserInfoDto(resultData200);
        return Promise.resolve<Types.UserInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserInfoDto>(null as any);
}

/**
 * Returns user's subscription info.
 */
export function getMySubscriptionInfo(config?: AxiosRequestConfig | undefined): Promise<Types.UserSubscriptionInfoDto> {
    let url_ = getBaseUrl() + "/api/user/subscription-info";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMySubscriptionInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetMySubscriptionInfo?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMySubscriptionInfo(_response);
    });
}

function processGetMySubscriptionInfo(response: AxiosResponse): Promise<Types.UserSubscriptionInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUserSubscriptionInfoDto(resultData200);
        return Promise.resolve<Types.UserSubscriptionInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserSubscriptionInfoDto>(null as any);
}

/**
 * Updates user's name.
 */
export function updateUserName(dto: Types.UpdateUserNameDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/user/username";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateUserNameDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateUserName,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdateUserName?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateUserName(_response);
    });
}

function processUpdateUserName(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Initiates migration from social network login to email/password authentication.
Sends a password setup link to the provided email address.
 */
export function migrateToEmailLogin(dto: Types.MigrateToEmailLoginDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/user/migrate-to-email-login";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeMigrateToEmailLoginDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigMigrateToEmailLogin,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigMigrateToEmailLogin?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMigrateToEmailLogin(_response);
    });
}

function processMigrateToEmailLogin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigRegisterNewUser: Partial<AxiosRequestConfig> | null;
export function getRegisterNewUserRequestConfig() {
  return _requestConfigRegisterNewUser;
}
export function setRegisterNewUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRegisterNewUser = value;
}
export function patchRegisterNewUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRegisterNewUser = patch(_requestConfigRegisterNewUser ?? {});
}

let _requestConfigConfirmUserMail: Partial<AxiosRequestConfig> | null;
export function getConfirmUserMailRequestConfig() {
  return _requestConfigConfirmUserMail;
}
export function setConfirmUserMailRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigConfirmUserMail = value;
}
export function patchConfirmUserMailRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigConfirmUserMail = patch(_requestConfigConfirmUserMail ?? {});
}

let _requestConfigSendPasswordForgotten: Partial<AxiosRequestConfig> | null;
export function getSendPasswordForgottenRequestConfig() {
  return _requestConfigSendPasswordForgotten;
}
export function setSendPasswordForgottenRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendPasswordForgotten = value;
}
export function patchSendPasswordForgottenRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendPasswordForgotten = patch(_requestConfigSendPasswordForgotten ?? {});
}

let _requestConfigResetPassword: Partial<AxiosRequestConfig> | null;
export function getResetPasswordRequestConfig() {
  return _requestConfigResetPassword;
}
export function setResetPasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = value;
}
export function patchResetPasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = patch(_requestConfigResetPassword ?? {});
}

let _requestConfigGetMyInfo: Partial<AxiosRequestConfig> | null;
export function getGetMyInfoRequestConfig() {
  return _requestConfigGetMyInfo;
}
export function setGetMyInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMyInfo = value;
}
export function patchGetMyInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMyInfo = patch(_requestConfigGetMyInfo ?? {});
}

let _requestConfigGetMySubscriptionInfo: Partial<AxiosRequestConfig> | null;
export function getGetMySubscriptionInfoRequestConfig() {
  return _requestConfigGetMySubscriptionInfo;
}
export function setGetMySubscriptionInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMySubscriptionInfo = value;
}
export function patchGetMySubscriptionInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMySubscriptionInfo = patch(_requestConfigGetMySubscriptionInfo ?? {});
}

let _requestConfigUpdateUserName: Partial<AxiosRequestConfig> | null;
export function getUpdateUserNameRequestConfig() {
  return _requestConfigUpdateUserName;
}
export function setUpdateUserNameRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateUserName = value;
}
export function patchUpdateUserNameRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateUserName = patch(_requestConfigUpdateUserName ?? {});
}

let _requestConfigMigrateToEmailLogin: Partial<AxiosRequestConfig> | null;
export function getMigrateToEmailLoginRequestConfig() {
  return _requestConfigMigrateToEmailLogin;
}
export function setMigrateToEmailLoginRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMigrateToEmailLogin = value;
}
export function patchMigrateToEmailLoginRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMigrateToEmailLogin = patch(_requestConfigMigrateToEmailLogin ?? {});
}